<template>
  <div class="box" v-loading="loading">
    <el-card>
      <div slot="header">
        <span>
          选择角色（角色选择成功后，可在右上角点击头像处进行角色切换）
        </span>
      </div>
      <el-table :data="tableData" border fit stripe>
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="privName" label="角色名称"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-d-arrow-right"
              @click="handleSwitch(scope.row.id)"
            >
              切换到这个角色
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { filterUrl } from '@/utils/validate';
import { listRoles, updateRole } from '@/api/systems/roles/switch.js';

export default {
  data() {
    return {
      loading: false,
      url: '',
      tableData: []
    };
  },
  methods: {
    handleSwitch(roleId) {
      if (roleId == 0) {
        this.msgError('角色必须大于0！');
        return;
      }
      this.loading = true;
      updateRole(roleId).then(res => {
        this.loading = false;
        window.open(this.url || '/');
      });
    },
    listRoles() {
      this.loading = true;
      listRoles().then(res => {
        this.tableData = res;
        this.loading = false;
      });
    }
  },
  created() {
    this.url = filterUrl(this.$route.query.redirect);
    this.listRoles();
  }
};
</script>

<style>
.box {
  padding: 50px;
}
</style>